import * as types from '../../action-types';
import AxiosCall from '../../../utils/axios';
import ErrorHandler from '../../../utils/error-handler';

export const getPersonalDataStart = () => ({
  type: types.GET_PERSONAL_DATA_START
});

export const getPersonalDataSuccess = payload => ({
  type: types.GET_PERSONAL_DATA_SUCCESS,
  payload
});

export const getPersonalDataFail = payload => ({
  type: types.GET_PERSONAL_DATA_FAIL,
  payload
});

export const getPersonalDataCleanup = () => ({
  type: types.GET_PERSONAL_DATA_CLEANUP
});

export const getPersonalData = ()=> async dispatch => {

  try {
    dispatch(getPersonalDataStart());
    const requestObj = {
      path: "users",
      method: "GET",
    }
    const  res  = await AxiosCall(requestObj);
    dispatch(getPersonalDataSuccess(res.data));
  } catch (err) {
    const error = ErrorHandler(err);
    dispatch(getPersonalDataFail(error));
  }
}
